import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Flex, Text } from "@jsq/ds/core";
import { ScreeningStatus } from "../cellStatus/ScreeningStatus";
import { ScreeningStatusType } from "../cellStatus/ScreeningStatus/types";
import { PositionData } from "../types";
import { cellContainer, cellText } from "./styles_vanilla.css";

interface ScreeningCellRendererProps extends ICellRendererParams {
  data: PositionData;
}

const ScreeningCellRenderer: React.FC<ScreeningCellRendererProps> = ({ data }) => {
  if (!data) return null;

  const { linkedProfile, successorCases } = data;
  const isGroupRow = successorCases && successorCases.length > 0;
  const isChildRow = data.parentId !== undefined;
  const isNotAttached =
    !data.linkedOnboardingCase ||
    ((!data.linkedOnboardingCase.profiles || data.linkedOnboardingCase.profiles.length === 0) &&
      !data.linkedOnboardingCase.investingProfile);

  if (isGroupRow) {
    return (
      <Flex className={cellContainer}>
        <Text className={cellText}></Text>
      </Flex>
    );
  }

  if (isNotAttached || isChildRow) {
    return <ScreeningStatus status="not-applicable" />;
  }

  // Show select payment beneficiary for normal rows when linkedProfile is null
  if (
    !isGroupRow &&
    (!successorCases || successorCases.length === 0) &&
    linkedProfile === null
  ) {
    return <ScreeningStatus status="select-payment-beneficiary" />;
  }

  // Map the screening record result to status type
  const getScreeningStatus = (result: string): ScreeningStatusType => {
    switch (result) {
      case "NoMatches":
        return "no-matches-found";
      case "PotentialMatches":
        return "potential-match";
      case "FalsePositive":
        return "false-positive";
      case "TrueMatch":
        return "true-match";
      case "AcceptedByGp":
        return "accepted-by-gp";
      case "RejectedByGp":
        return "rejected-by-gp";
      default:
        return "select-payment-beneficiary";
    }
  };

  return (
    <ScreeningStatus
      status={getScreeningStatus(
        linkedProfile?.screeningRecord?.result || "SelectPaymentBeneficiary",
      )}
      caseId={data.caseId}
      profileId={data.linkedProfileId || -1}
      programId={data.linkedOnboardingCase?.program.id || -1}
    />
  );
};

export default ScreeningCellRenderer;
